// extracted by mini-css-extract-plugin
export default {"calendarEventIsComingMarginInputMargin":"calendarEventIsComingMarginInputMargin__iXif2","calendarEventIsComingGroupMargin":"calendarEventIsComingGroupMargin__Cb1ks"};